import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=d803cb38&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=tsx&"
export * from "./taskDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=d803cb38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d803cb38",
  null
  
)

export default component.exports